export default __webpack_public_path__ + "static/media/prod~ZWCqulgJ.781a7cab.svg";